import { useParams } from "react-router-dom";
import { useEffect, useMemo, useRef, useState } from "react";

import Navigator from "./components/navigator/Navigator";
import {  DeviceDetailsContent, ScreenBorderLeft, ChartLeftWrappers, ChartRightWrappers, DeviceImageInformationandAlarmWrappers, DeviceInformationWrappers, DeviceAlarmWrappers, ScreenBorderRight, ScreenBorderBottom, ScreenBorderTop, DeviceDetailsScreenInnerWrapper, DeviceDetailsScreenWrapper, DeviceImageandDetailsWrapper,DeviceImageWrapper, DeviceDetailsWrapper, DeviceModel3DAndHealthWrapper, DeviceModel3DWrapper, DeviceTrackWrapper, ScreenTitleBar } from "./DeviceDetailsScreen.styled";
import MovingMotorContentCard from "./common/moving-motor-content-card/MovingMotorContentCard";
import DeviceMetrics from "./components/device-metrics/DeviceMetrics";
import DeviceDetails from "./components/device-details/DeviceDetails"
import DeviceAlarms from "./components/device-alarms/DeviceAlarms";

import DeviceApi from "../../../../api/DeviceApi";
import DeviceMetricApi from "../../../../api/DeviceMetricApi";

import StringUtils from "../../../../util/StringUtils";


interface DeviceDetailsScreenProps {

}

let DeviceDetailsScreen: React.FC<DeviceDetailsScreenProps> = (props)=> {
    // parameters
    let params = useParams();
    let { deviceId } = useParams();

    // api
    let deviceApi = new DeviceApi();
    let deviceMetricApi = new DeviceMetricApi();

    // state
    let [deviceView, setDeviceView] = useState<any>(null);
    let [deviceTemplateProperties, setDeviceTemplateProperties] = useState([]);
    let [latestDeviceMetrics, setLatestDeviceMetrics] = useState<any>({});
    // alarm presence state
    let [hasAlarmEvents, setHasAlarmEvents] = useState<boolean | null>(null);
    let [isAlarmEventsChecked, setAlarmEventsChecked] = useState(false);

    // functions
    let fetchLatestDeviceMetrics = async (deviceId: string)=> {
        let latestDeviceMetrics = (await deviceMetricApi.getLatestDeviceMetricsView(deviceId)).data.data;
        setLatestDeviceMetrics(latestDeviceMetrics);
    };

    let fetchDeviceView = async (deviceId: string)=> {
            // load device views
            let deviceView = (await deviceApi.getDeviceViewByDeviceId(deviceId)).data.data;
            setDeviceView(deviceView);
    
            // parse template properties
            let deviceTemplate = deviceView.deviceTemplate;
            let configuration = JSON.parse(StringUtils.emptyToDefault(deviceTemplate.configuration, "{}"));
            let properties = configuration.properties;
            setDeviceTemplateProperties(properties);
    
            // fetch metrics
            await fetchLatestDeviceMetrics(deviceId);
    };

    // effect
    useEffect(()=> {
        fetchDeviceView(deviceId);



        let refreshTask = window.setInterval(()=> {
            fetchLatestDeviceMetrics(deviceId);
        }, 5000);
        
        // unload
        return ()=> {
            window.clearInterval(refreshTask);
        }
    }, []);

    let getProperty = (propertyKey: string)=> {
        return deviceTemplateProperties.find((e: any) => e.key === propertyKey);
    };

    let getUnit = (propertyKey: string)=> {
        let property = getProperty(propertyKey);
        let unit = property?.unit;
        return unit != null && unit !== "" ? unit : "";
    };

    let getValue = (propertyKey: string)=> {
        let value = latestDeviceMetrics[propertyKey]?.value;;
        return value != null && value !== "" ? value : "";
    };

    // render
    return (
        <DeviceDetailsScreenWrapper>
            
            <DeviceDetailsScreenInnerWrapper>
                <ScreenBorderTop>
                    <ScreenTitleBar>
                        <Navigator selected="DEVICE_DETAILS" />
                    </ScreenTitleBar>
                </ScreenBorderTop>
                <ScreenBorderBottom/>
                <ScreenBorderLeft/>
                <ScreenBorderRight/>
                
                <DeviceDetailsContent>
                    <DeviceImageInformationandAlarmWrappers>
                        <DeviceInformationWrappers><DeviceDetails deviceId={deviceId}/></DeviceInformationWrappers>
                        <DeviceAlarmWrappers><DeviceAlarms deviceId={deviceId}/></DeviceAlarmWrappers>
                       
                        <DeviceImageandDetailsWrapper>
                            <DeviceImageWrapper/>
                            <MovingMotorContentCard 
                                titleCn="走行电机1"
                                data={getValue('movingMotor1Speed') + getUnit('movingMotor1Speed')}
                                style={{
                                    gridColumn: '1 / 2',
                                    gridRow: '1 / 4',
                                    marginLeft: '135px',
                                    marginTop:'27px',
                                }}
                                titlestyle={{
                                marginLeft: '25px',
                                }}
                            >
                            </MovingMotorContentCard> 

                            <MovingMotorContentCard 
                                titleCn="走行电机2"
                                data={getValue('movingMotor2Speed') + getUnit('movingMotor2Speed')}
                                style={{
                                    gridColumn: '3 / 4',
                                    gridRow: '1 / 4',
                                    marginTop:'27px',
                                }}
                                titlestyle={{
                                marginLeft: '20px',
                                }}
                            >
                            </MovingMotorContentCard> 

                            <MovingMotorContentCard 
                                titleCn="走行电机3"
                                data={getValue('movingMotor3Speed') + getUnit('movingMotor3Speed')}
                                style={{
                                    gridColumn: '1 / 2',
                                    gridRow: '4 / 7',
                                    marginLeft: '50px',
                                    marginTop:'77px',
                                }}
                                titlestyle={{
                                marginLeft: '10px',
                                }}
                            >
                            </MovingMotorContentCard> 

                            <MovingMotorContentCard 
                                titleCn="走行电机4"
                                data={getValue('movingMotor4Speed') + getUnit('movingMotor4Speed')}
                                style={{
                                    gridColumn: '3 / 4',
                                    gridRow: '4 / 7',
                                    marginLeft: '80px',
                                    marginTop:'77px',
                                }}
                                titlestyle={{
                                marginLeft: '20px',
                                }}
                            >
                            </MovingMotorContentCard> 
                        </DeviceImageandDetailsWrapper>
                    </DeviceImageInformationandAlarmWrappers>

                    <ChartLeftWrappers>
                        <DeviceMetrics deviceId={deviceId} propertyKey={['movingMotor1Temp','movingMotor1Current','movingMotor3Temp','movingMotor3Current']}></DeviceMetrics>
                    </ChartLeftWrappers>

                    <ChartRightWrappers>
                        <DeviceMetrics deviceId={deviceId} propertyKey={['movingMotor2Temp','movingMotor2Current','movingMotor4Temp','movingMotor4Current']}></DeviceMetrics>
                    </ChartRightWrappers>
                </DeviceDetailsContent>
            </DeviceDetailsScreenInnerWrapper>

            
           

        </DeviceDetailsScreenWrapper>
    );
}

export default DeviceDetailsScreen;
